import {state as appStoreDialogState} from "@/store/modules/AppStoreDialog/appStoreDialog";
import {getters as appStoreGetters} from "@/store/modules/AppStoreDialog/appStoreDialog";
import {state as appState} from "@/store/modules/app";

export default function appStoreDialogFlags() {

    return {
        canManageApp,
        canSeeAllTabs,
        canManageAccount,
        canEditTopics,
        canActivateApp,
        canDeactivateApp,
        canSubscribe,

        hasTrial,
        hasPaid,
        isFeatureActive,

        isSoftLaunch,
    }

    function hasTrial() {
        const result = appStoreGetters.getCurrentPlan()
        // console.log('hasTrial', result)
        return result && result.is_trial ? 1 : 0
    }

    function hasPaid() {
        const result = appStoreGetters.getCurrentPlan()
        // console.log('hasPaid', result)
        return result && result.is_paid ? 1 : 0
    }

    function canManageApp() {
        return canManageAccount() && (hasTrial() || hasPaid())
    }

    function canActivateApp() {
        return canManageApp() && !isFeatureActive()
    }

    function canDeactivateApp() {
        if (isSoftLaunch()) {
            return isSoftLaunchSignedUp()
        }
        return canManageApp() && isFeatureActive()
    }

    function isFeatureActive() {
        const app = appStoreGetters.getCurrentFeature()
        const result = app && app.status === 'active'
        // console.log('isFeatureActive', result)
        return result
    }

    function canManageAccount() {
        let account = appStoreGetters.getSelectedCompany()
        const result = (account.rights & appState.rights_masks.manage_account) === appState.rights_masks.manage_account
        // console.log('canManageAccount', result)
        return result
    }

    function canSeeAllTabs() {
        const result = canManageApp() && isFeatureActive()
        // console.log('canSeeAllTabs', result)
        return result
    }

    function canEditTopics() {
        let account = appStoreGetters.getSelectedCompany()
        return canManageAccount() || !account.data.topic_management_disabled_for_users;
    }

    function canSubscribe() {
        return canManageApp() && !isFeatureActive()
    }

    function isDemo() {
        let account = appStoreGetters.getSelectedCompany()
        return Boolean(account.data.is_demo)
    }

    function isSoftLaunch() {
        const appData = appStoreDialogState.appData
        return !appData.is_activatable
    }

    function isSoftLaunchSignedUp() {
        const appData = appStoreDialogState.appData
        const company = appStoreGetters.getSelectedCompany()
        const _key = `is_${appData.name}_subscribed`
        return !!company.data[_key]
    }
}
